import { getPlayerData } from "core-integration/src/store/player/reducers";
import { Sheet } from "plos/src/components/Sheet";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useOnboardingContext } from "../../../contexts/OnboardingContext";
import { AutoPickChoice } from "./AutoPickChoice";
import { EntryDetailsForm } from "./EntryDetailsForm";
import { OnboardingButtons } from "./OnboardingButtons";
import { TeamBuilderWizard } from "./TeamBuilder";
import { EntryDetailsFormData } from "./types";
import { getDefaultTeamName } from "./utils";

interface OnboardingProps {
  isOpen: boolean;
}

const Onboarding = ({ isOpen }: OnboardingProps) => {
  const { t } = useTranslation("onboarding");
  const { activeSurface, entryDetails, handleClose } = useOnboardingContext();
  const player = useSelector(getPlayerData);

  const { control, handleSubmit, watch } = useForm<EntryDetailsFormData>({
    mode: "onChange",
    defaultValues: entryDetails ?? {
      name: getDefaultTeamName(t, player?.first_name),
      favourite_team: null,
      terms_agreed: false,
    },
  });

  if (!isOpen) {
    return null;
  }

  if (activeSurface === "wizard") {
    return (
      <TeamBuilderWizard favouriteTeam={entryDetails?.favourite_team ?? null} />
    );
  }

  return (
    <Sheet
      open={isOpen}
      handleClose={handleClose}
      isDismissable={false}
      footer={<OnboardingButtons handleSubmit={handleSubmit} watch={watch} />}
    >
      {(() => {
        switch (activeSurface) {
          case "entryDetails":
            return <EntryDetailsForm control={control} />;
          case "autopickChoice":
            return <AutoPickChoice />;
          default:
            return null;
        }
      })()}
    </Sheet>
  );
};

export default Onboarding;
